import { type FC, type ReactNode } from 'react';

import { ListItem, ListItemIcon, ListItemText, Tooltip } from '@mui/material';

import type { Proposal } from 'api/projectVersioning/types';

import StatusIcon from '../StatusIcon';

type ProposalListRowProps = {
  proposal: Proposal;
  secondaryText: string;
  variant: 'active' | 'history';
  actions?: ReactNode;
};

export const ProposalListRow: FC<ProposalListRowProps> = ({ proposal, secondaryText, variant, actions }) => {
  if (variant === 'active') {
    return (
      <ListItem secondaryAction={actions} data-testid={`proposal-row-${proposal.name}`}>
        <ListItemIcon sx={{ mr: 3 }}>
          <StatusIcon status={proposal.status} />
        </ListItemIcon>
        <ListItemText primary={proposal.name} secondary={secondaryText} />
      </ListItem>
    );
  }

  return (
    <ListItem data-testid={`proposal-row-${proposal.name}`}>
      <ListItemIcon sx={{ mr: 3 }}>
        <StatusIcon status={proposal.status} />
      </ListItemIcon>
      <Tooltip title={`${proposal.name} is part of your history. No actions are available for historic proposals.`}>
        <ListItemText primary={proposal.name} secondary={secondaryText} />
      </Tooltip>
    </ListItem>
  );
};
